import SuiBox from "components/SuiBox";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <SuiBox sx={{ py: 1 }}>
          <div>{children}</div>
        </SuiBox>
      )}
    </div>
  );
}

export default TabPanel;
